import { Component, Input } from "@angular/core";

@Component({
    selector:'app-poshvine-icon-tray',
    templateUrl:'./icon-tray.component.html',
    styleUrls:['./icon-tray.component.scss']

})
export class IconTrayComponent{
    @Input() badges = [1,2,3,4,5,6,7];
    @Input() trayLimit = 3;
    constructor(){

    }
}